module.exports = new __parcel__URL__("tetris-dx.09b65387.jpg").toString();